// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app_header {
  padding: 15px 0px;
  border-bottom: 1px solid #2f2b2b;
}
.app_header .app_logo {
  margin-right: 60px;
}
.app_header .app_logo img {
  width: 30px;
}
.app_header .navbar-expand-lg .navbar-nav .nav-link,
.app_header .navbar-expand-lg .navbar-nav a {
  color: var(--light-color);
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  padding: 10px;
}
.app_header .header_btn_wrap .header_btn {
  background: var(--primary-color);
  color: var(--dark-color);
  border-radius: 20px;
  font-weight: 500;
  font-size: 14px;
  padding: 6px 15px;
}
.app_header .header_btn_wrap .header_btn img {
  margin-right: 8px;
  border-radius: 100px;
  height: 24px;
  width: 24px;
}
.app_header .header_btn_wrap .header_btn span {
  vertical-align: middle;
}
.app_header button:focus {
  box-shadow: none;
}
.app_header .dropdown_wrap .header_btn img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.app_header .dropdown_wrap .dropdown .btn-success {
  background: var(--primary-color);
  color: var(--dark-color);
  border-radius: 20px;
  font-weight: 500;
  font-size: 14px;
  border-color: #FBCBA7;
}
.app_header .dropdown_wrap .dropdown .btn-success::after {
  display: none;
}
.app_header .dropdown_wrap .dropdown .dropdown-menu {
  left: -220px;
  background-color: var(--secondary-color);
  border: 1px solid #39424c;
  border-radius: 12px;
  width: 320px;
  box-shadow: 0px 4px 16px -1px rgba(0, 0, 0, 0.08), 0px 0px 8px -4px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  padding: 10px 15px;
}
.app_header .dropdown_wrap .dropdown .dropdown-menu .user_profile_wrap {
  margin-bottom: 15px;
}
.app_header .dropdown_wrap .dropdown .dropdown-menu .user_profile_wrap .user_profile {
  text-align: center;
}
.app_header .dropdown_wrap .dropdown .dropdown-menu .user_profile_wrap .user_profile img {
  width: 80px;
  border-radius: 50%;
  height: 80px;
}
.app_header .dropdown_wrap .dropdown .dropdown-menu .user_profile_wrap h4 {
  font-size: 18px;
  text-align: center;
  color: var(--light-color);
}
.app_header .dropdown_wrap .dropdown .dropdown-menu .user_profile_wrap h4 .text_copied {
  font-size: 12px;
  background: var(--secondary-color);
  padding: 4px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 0px #3a3a3b;
  position: relative;
  top: -23px;
  left: -35px;
}
.app_header .dropdown_wrap .dropdown .dropdown-menu .user_profile_wrap h4 span {
  cursor: pointer;
}
.app_header .dropdown_wrap .dropdown .dropdown-menu .dropdown-item {
  padding: 6px 8px;
  color: var(--text-color);
}
.app_header .dropdown_wrap .dropdown .dropdown-menu .dropdown-item:hover {
  background-color: var(--button-color);
}
.app_header .dropdown_wrap .dropdown .dropdown-menu .dropdown-item svg {
  font-size: 20px;
  margin-right: 5px;
  vertical-align: middle;
}
.app_header .dropdown_wrap .disconnect_btn {
  background: var(--primary-color);
  color: var(--dark-color);
  border-radius: 20px;
  font-weight: 500;
  font-size: 14px;
  border-color: #FBCBA7;
}
.app_header .right_header_wrap {
  display: flex;
}

@media screen and (max-width: 991px) {
  .app_header {
    padding: 0px;
  }
  .app_header .header_btn_wrap .header_btn {
    margin-bottom: 5px;
  }
  .app_header .right_header_wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
  }
}
@media screen and (max-width: 380px) {
  .app_header .dropdown_wrap .dropdown .dropdown-menu {
    left: -80px;
    width: 211px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/common/header.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,gCAAA;AACJ;AACI;EACI,kBAAA;AACR;AACQ;EACI,WAAA;AACZ;AAMY;;EAEI,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;AAJhB;AAUQ;EAQI,gCAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAfZ;AAGY;EACI,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;AADhB;AAWY;EACI,sBAAA;AAThB;AAeQ;EACI,gBAAA;AAbZ;AAmBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAjBhB;AAuBY;EACI,gCAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AArBhB;AAuBgB;EACI,aAAA;AArBpB;AAyBY;EACI,YAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,uFAAA;EACA,gBAAA;EACA,kBAAA;AAvBhB;AAyBgB;EACI,mBAAA;AAvBpB;AAyBoB;EACI,kBAAA;AAvBxB;AAyBwB;EACI,WAAA;EACA,kBAAA;EACA,YAAA;AAvB5B;AA2BoB;EACI,eAAA;EACA,kBAAA;EACA,yBAAA;AAzBxB;AA2BwB;EACI,eAAA;EACA,kCAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AAzB5B;AA4BwB;EACI,eAAA;AA1B5B;AA+BgB;EACI,gBAAA;EACA,wBAAA;AA7BpB;AA+BoB;EACI,qCAAA;AA7BxB;AAgCoB;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;AA9BxB;AAoCQ;EACI,gCAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAlCZ;AAsCI;EACI,aAAA;AApCR;;AAwCA;EACI;IACI,YAAA;EArCN;EAwCE;IACI,kBAAA;EAtCN;EAyCE;IACI,aAAA;IACA,8BAAA;IACA,gBAAA;EAvCN;AACF;AA2CA;EACI;IACI,WAAA;IACA,YAAA;EAzCN;AACF","sourcesContent":[".app_header {\n    padding: 15px 0px;\n    border-bottom: 1px solid #2f2b2b;\n\n    .app_logo {\n        margin-right: 60px;\n\n        img {\n            width: 30px;\n        }\n    }\n\n    .navbar-expand-lg {\n        .navbar-nav {\n\n            .nav-link,\n            a {\n                color: var(--light-color);\n                font-weight: 500;\n                font-size: 14px;\n                text-decoration: none;\n                padding: 10px;\n            }\n        }\n    }\n\n    .header_btn_wrap {\n        .header_btn {\n            img {\n                margin-right: 8px;\n                border-radius: 100px;\n                height: 24px;\n                width: 24px;\n            }\n\n            background: var(--primary-color);\n            color: var(--dark-color);\n            border-radius: 20px;\n            font-weight: 500;\n            font-size: 14px;\n            padding: 6px 15px;\n\n            span {\n                vertical-align: middle;\n            }\n        }\n    }\n\n    button {\n        &:focus {\n            box-shadow: none;\n        }\n    }\n\n    .dropdown_wrap {\n        .header_btn {\n            img {\n                width: 20px;\n                height: 20px;\n                margin-right: 5px;\n            }\n        }\n\n        .dropdown {\n\n            .btn-success {\n                background: var(--primary-color);\n                color: var(--dark-color);\n                border-radius: 20px;\n                font-weight: 500;\n                font-size: 14px;\n                border-color: #FBCBA7;\n\n                &::after {\n                    display: none;\n                }\n            }\n\n            .dropdown-menu {\n                left: -220px;\n                background-color: var(--secondary-color);\n                border: 1px solid #39424c;\n                border-radius: 12px;\n                width: 320px;\n                box-shadow: 0px 4px 16px -1px rgba(0, 0, 0, .08), 0px 0px 8px -4px rgba(0, 0, 0, .12);\n                overflow: hidden;\n                padding: 10px 15px;\n\n                .user_profile_wrap {\n                    margin-bottom: 15px;\n\n                    .user_profile {\n                        text-align: center;\n\n                        img {\n                            width: 80px;\n                            border-radius: 50%;\n                            height: 80px;\n                        }\n                    }\n\n                    h4 {\n                        font-size: 18px;\n                        text-align: center;\n                        color: var(--light-color);\n\n                        .text_copied {\n                            font-size: 12px;\n                            background: var(--secondary-color);\n                            padding: 4px;\n                            border-radius: 5px;\n                            box-shadow: 0px 0px 10px 0px #3a3a3b;\n                            position: relative;\n                            top: -23px;\n                            left: -35px;\n                        }\n\n                        span {\n                            cursor: pointer;\n                        }\n                    }\n                }\n\n                .dropdown-item {\n                    padding: 6px 8px;\n                    color: var(--text-color);\n\n                    &:hover {\n                        background-color: var(--button-color);\n                    }\n\n                    svg {\n                        font-size: 20px;\n                        margin-right: 5px;\n                        vertical-align: middle;\n                    }\n                }\n            }\n        }\n\n        .disconnect_btn {\n            background: var(--primary-color);\n            color: var(--dark-color);\n            border-radius: 20px;\n            font-weight: 500;\n            font-size: 14px;\n            border-color: #FBCBA7;\n        }\n    }\n\n    .right_header_wrap {\n        display: flex;\n    }\n}\n\n@media screen and (max-width:991px) {\n    .app_header {\n        padding: 0px;\n    }\n\n    .app_header .header_btn_wrap .header_btn {\n        margin-bottom: 5px;\n    }\n\n    .app_header .right_header_wrap {\n        display: flex;\n        justify-content: space-between;\n        margin-top: 15px;\n    }\n\n}\n\n@media screen and (max-width:380px) {\n    .app_header .dropdown_wrap .dropdown .dropdown-menu {\n        left: -80px;\n        width: 211px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
